export enum ObjectPageTabs {
  EMAIL = 'Mail',
  TELEGRAM = 'Telegram',
  WHATS = ' WhatsApp',
  MESSAGES = 'Twilio',
  ACTIVITY = 'Activity',
  SCHEME = 'Scheme',
  MAIN = 'Main',
  CHILD = 'Child',
  DOCS = 'Docs',
  INVOICES = 'Invoices',
}

export enum SkeletonType {
  LEFT = 'LEFT',
  RIGHT = 'RIGHt',
}
